export default __webpack_public_path__ + "static/media/convenient.f0b3c31f.webp";